export default class LiveSearchTakeover {
  constructor({
    liveSearch,
    events,
    triggerEls,
    takeoverEl,
  }) {
    const closeEl = takeoverEl.querySelector('[data-search-cancel-button]');
    this.liveSearch = liveSearch;
    this.events = events;
    this.previousFocus = null;
    this.open = false;
    this.animation = Core.Animations.transition({ el: takeoverEl, state: 'closed' });
    triggerEls.forEach(el => {
      events.register(el, 'click', e => this._handleTriggerClick(e));
    });
    events.register(closeEl, 'click', () => this._close());
    events.register(document, 'click', e => {
      if (takeoverEl.contains(e.target)) return;

      this._close();
    });
    events.register(takeoverEl, 'focusout', () => {
      window.requestAnimationFrame(() => {
        if (!takeoverEl.contains(document.activeElement)) this._close();
      });
    });
  }

  _handleTriggerClick(e) {
    e.preventDefault();
    const escapeEvent = this.events.register(window, 'keyup', keyevent => {
      if (keyevent.key === 'Escape') {
        this.events.unregister(escapeEvent);
        this._close();
      }
    });
    this._open();
  }

  _open() {
    if (this.open) return;

    this.animation.animateTo('open')
      .then(() => {
        this.previousFocus = document.activeElement;
        this.liveSearch.focus();
        this.open = true;
      });
  }

  _close() {
    if (!this.open) return;

    this.liveSearch.close()
      .then(() => this.animation.animateTo('closed'))
      .then(() => {
        if (this.previousFocus) this.previousFocus.focus();
        this.open = false;
      });
  }
}
